module.exports = __webpack_public_path__ + "img/Yacky.1ce14cd7.webp";